import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Divider } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { toast } from 'react-toastify';
import api from './api';

const WorkflowsDialog = ({ open, onClose, onSelect, workflows, onWorkflowsChange }) => {
  const [selected, setSelected] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleDelete = async (wf) => {
    if (busy) return; setBusy(true);
    try {
      const usage = await api.checkWorkflowUsage(wf.name);
      if (usage && usage.length) {
        toast.warning(`Bu workflow şu görevlerde kullanılıyor: ${usage.map(u => u.name).join(', ')}`);
        return;
      }
      await api.deleteWorkflow(wf.name);
      toast.success('Workflow silindi');
      onWorkflowsChange((workflows || []).filter(w => w.name !== wf.name));
    } catch (e) {
      toast.error(e?.response?.data?.message || e.message || 'Silme sırasında hata');
    } finally {
      setBusy(false);
    }
  };

  const handleSelect = (wf) => {
    setSelected(wf);
    onSelect(wf.name);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Kayıtlı Workflows</DialogTitle>
      <Divider />
      <DialogContent dividers>
        <List>
          {(workflows || []).length === 0 ? (
            <ListItem><ListItemText primary="Kayıtlı workflow bulunamadı" /></ListItem>
          ) : (
            (workflows || []).map((wf) => (
              <React.Fragment key={wf.name}>
                <ListItem button onClick={() => handleSelect(wf)} selected={selected?.name === wf.name}>
                  <ListItemText primary={wf.name} secondary={wf.description || ''} />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" onClick={(e) => { e.stopPropagation(); handleDelete(wf); }} size="small" disabled={busy}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider component="li" />
              </React.Fragment>
            ))
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Kapat</Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkflowsDialog;

